<template>
  <div class="bg-white rounded box-shadow my-1 p-3">
    <div class="row">
      <div v-if="show" class="alert alert-danger alert-dismissible fade show" role="alert">
                <span v-for="(err, index) in validation_errors" :key="index">
                  {{ err[0] }} <br />
                </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <h5 class="float-left">4.1 Detail description of affected trees on own land: No. of Affected Trees as per size/Type:</h5>
      </div>
      <div class="col-md-3">
        <b-button v-b-modal.tree-modal type="button" class="btn btn-success float-right btn-sm mb-1 text-black"
                  @click="$bvModal.show('tree-modal'), resetForm()">
          Add tree
          <i class="fas fa-plus"></i>
        </b-button>
      </div>
    </div>
    <div class="scrollable-table">
      <table class="table table-centered table-striped" style="overflow-x: auto">
        <thead>
        <tr>
          <th>SL</th>
          <th>Land Info</th>
          <th>Name of Tree</th>
          <th>Tree type</th>
          <th>Large (Nos.)</th>
          <th>Medium (Nos.)</th>
          <th>Small (Nos.)</th>
          <th>Yearly income (BDT)</th>
          <th>CCL No</th>
          <th>Amount</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(tree, index) in trees" :key="index">
          <td>{{ index + 1 }}</td>
          <td>Land id: {{ tree.land.id }}, Mouza: {{ tree.land.mouza.mouza_desc }}, Plot: {{ tree.land.plot_no }}</td>
          <td>{{ tree.tree_name.tree_name_desc }}</td>
          <td>{{ tree.tree_type.tree_type_desc }}</td>
          <td>{{ tree.tree_large }}</td>
          <td>{{ tree.tree_medium }}</td>
          <td>{{ tree.tree_small }}</td>
          <td>{{ tree.yearly_income }}</td>
          <td> <span v-if="tree.ccl_tree"> {{ tree.ccl_tree.ccl ? tree.ccl_tree.ccl.ccl_no : '' }}</span></td>
          <td>{{ tree.ccl_tree ? tree.ccl_tree.ccl_amount : ''}}</td>
          <td>
            <b-button variant="info"
                      class="btn btn-info btn-xs waves-effect waves-light  mr-2"
                      @click.prevent="viewTree(tree)">
              <i class="mdi mdi-account-card-details"></i></b-button>

            <b-button v-if="(tree.payment_tree == null)" variant="warning"
                      class="btn btn-warning btn-xs waves-effect waves-light  mr-2"
                      @click.prevent="getTree(tree), $bvModal.show('tree-modal')">
              <i class="far fa-edit"></i>
            </b-button>
            <b-button v-if="(tree.payment_tree == null)" variant="danger"
                      class="btn btn-warning btn-xs waves-effect waves-light"
                      @click.prevent="softDelete(tree.id)"><i
                class="far fa-trash-alt"></i>
            </b-button>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="loader" class="loader">Loading...</div>
      <h5 v-if="trees.length === 0" class="text-center text-secondary">
        No Data Found
      </h5>
    </div>
    <tree-modal
        :tree="tree"
        :cclShow="cclShow"
        :btn_edit="btn_edit"
        @cclShowUpdate="cclShowUpdate"
        @getPersonTree="getPersonTree"
        @resetForm="resetForm"
    ></tree-modal>
    <tree-modal-view
        :tree_list="tree_list"
        @getPersonTree="getPersonTree">
    </tree-modal-view>
  </div>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

import TreeModal from "../../modals/TreeModal";
import TreeModalView from "../../modals/TreeModalView";

export default {
  page: {
    title: "Search Tree",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, TreeModal, TreeModalView},
  data() {
    return {
      title: "Search Tree",
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'Search',
          active: true,
        },
      ],
      trees: {},
      tree: {},
      btn_edit: false,
      validation_errors: {},
      show: false,
      cclShow: false,
      tree_list: {},
      loader: false
    };
  },

  mounted() {
    this.tree.ses_id = this.$route.params.ses_id;
    this.getPersonTree();
  },

  methods: {
    getTree(tree) {
      this.tree = {};
      this.btn_edit = true;

      http.get("api/trees/" + tree.id + "/edit").then(response => {
        if (!response.error) {

          this.tree = response.data.tree;
          this.tree.land_ownership_type_id == 1
              ? (this.cclShow = true)
              : (this.cclShow = false);

          this.$children[0].getCcls(this.tree.plot_no,this.tree.mouza_id);
          setTimeout(() => {  this.$children[0].getCclInfo(this.tree.ccl_id); }, 2000);
        }
      });
    },
    softDelete(tree_id) {
      if (confirm("Do you really want to delete?")) {
        http.delete("api/trees/" + tree_id).then(response => {
          if (!response.error) {
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
              variant: "success"
            });
            this.getPersonTree();
          } else {
            this.$bvToast.toast("Deleted Failed", {
              title: "Error",
              autoHideDelay: 5000,
              variant: "danger"
            });
          }
        });
      }
    },
    getPersonTree() {
      this.loader = true
      let ses_id = this.$route.params.ses_id;
      http.get("api/tree/getPersonTree/" +  ses_id)
          .then(response => {
            if (!response.error) {
              this.loader = false

              this.trees = response.data.trees;
              this.$children[0].trees=this.trees;


            }
          });
    },
    resetForm() {
      this.btn_edit = false;
      this.tree = {};
      this.tree.ses_id = this.$route.params.ses_id;
      this.tree.land_id = "";
      this.$children[0].getCodes()
    },
    cclShowUpdate(value) {
      this.cclShow = value;
    },
    viewTree(tree){
      this.tree_list = {};
      this.tree_list = tree;
      this.$root.$emit("bv::show::modal", "tree-modal-view");
    },
  },
};
</script>
